import React from 'react';
import TodoItem from './TodoItem';
import { ITodo } from '../interfaces/todo';

interface TodosProps {
  todos: ITodo[];
  markComplete: any;
  delTodo: any;
}

class Todos extends React.Component<TodosProps> {
  constructor(props: TodosProps) {
    super(props);
    this.setState({ ...props.todos });
  }

  render() {
    return this.props.todos.map((todo) => (
      <TodoItem
        key={todo.id}
        todo={todo}
        markComplete={this.props.markComplete}
        delTodo={this.props.delTodo}
      />
    ));
  }
}
export default Todos;
